import { Box, Typography } from '@mui/material'
import { CALCULATE_ADVANCE } from 'constants/status'
import { useTranslation } from 'react-i18next'

const OpCalAdvance = () => {
    const { t } = useTranslation()
    const optionCalAdvance = [
        {
            name: t('BRANCH.TAB.SENTTING.PAY_DECREASE'), value: CALCULATE_ADVANCE.DECREASE,
            component: <CalAdvance showType='DECREASE' />,
        },
        {
            name: t('BRANCH.TAB.SENTTING.PAY_INCREASE'), value: CALCULATE_ADVANCE.INCREASE,
            component: <CalAdvance showType='INCREASE' />,
        }
    ]
    return (optionCalAdvance)
}

export default OpCalAdvance

interface CalAdvanceProps {
    showType: 'DECREASE' | 'INCREASE'
}
const CalAdvance = (props: CalAdvanceProps) => {
    const { showType } = props
    const { t } = useTranslation()

    return (
        <Box display='flex' flexDirection='column' gap='16px' height='100%'>
            <Box>
                <Typography fontSize={'20px'} fontWeight={'500'} marginBottom='8px'>
                    {t('BRANCH.TAB.SENTTING.CAL_ADVANCE')}
                </Typography>
            </Box>

            <Box>
                <Typography fontSize={'16px'} fontWeight={'500'} marginBottom='8px'>
                    {t(`BRANCH.TAB.SENTTING.PAY_${showType}`)}
                </Typography>
                <Typography fontWeight={'400'} paddingLeft='20px' color='#5A5A5A'>
                    {t(`BRANCH.TAB.SENTTING.SUB_PAY_${showType}`)}
                </Typography>
            </Box>

            <Box>
                <Typography fontSize={'16px'} fontWeight={'500'} marginBottom='8px'>
                    {t(`BRANCH.TAB.SENTTING.EXAMPLE_SHORT`)}
                </Typography>
                <Box marginTop="8px" padding="16px" bgcolor={'#ffffff'} fontStyle="italic">
                    <Typography fontSize={'16px'} fontWeight={'400'} paddingLeft='20px' color='#5A5A5A' marginBottom='16px'>
                        {t(`BRANCH.TAB.SENTTING.ADVANCE.DAY1_ADVANCE`)}
                    </Typography>
                    <Typography fontSize={'16px'} fontWeight={'400'} paddingLeft='20px' color='#5A5A5A' marginBottom='24px' marginTop='24px'>
                        {t(`BRANCH.TAB.SENTTING.ADVANCE.DAY1_TOTAL`, { advance: `${showType === 'DECREASE' ? '1000' : '2000'}` })}
                    </Typography>
                    <Typography fontSize={'16px'} fontWeight={'400'} paddingLeft='20px' color='#5A5A5A' marginBottom='16px'>
                        {t(`BRANCH.TAB.SENTTING.ADVANCE.DAY2_TREATMENT`)}
                    </Typography>
                    <Typography fontSize={'16px'} fontWeight={'400'} paddingLeft='20px' color='#5A5A5A' marginBottom='16px'>
                        {t(`BRANCH.TAB.SENTTING.ADVANCE.DAY2_TOTAL`, { advance: `${showType === 'DECREASE' ? '2000' : '1000'}` })}
                    </Typography>
                </Box>
            </Box>
        </Box>
    )
}